import './consultar-alteracao-produto-controller';
